/** Logged-in candidate job detail URL (`/candidate/jobs/:slug` or marketplace variant). */
export function candidateJobDetailPath(input: {
  public_slug?: string | null
  id: string
  kind?: 'managed' | 'marketplace'
}): string {
  if (input.kind === 'marketplace') {
    return `/candidate/jobs/marketplace/${encodeURIComponent(input.id.trim())}`
  }
  const slug = input.public_slug?.trim() || input.id.trim()
  if (!slug) return '/candidate/jobs'
  return `/candidate/jobs/${encodeURIComponent(slug)}`
}
